let baseURL = "https://qa-autocarrevampapi.appinsnap.com";
// let baseURL = "https://api.car2parts.com";
// let baseURL = "http://192.168.10.22:3005";
// let baseURL = "http://20.212.227.60:3095";

export { baseURL };
